import 'react';

const DialogCloseSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="1em" height="1em" viewBox="0 0 20 20" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" />
            <path
                stroke="#878D99"
                strokeWidth={1.25}
                strokeLinecap="round"
                d="M5.799 6l8.485 8.485M14.284 6L5.8 14.485"
            />
        </g>
    </svg>
);

export default DialogCloseSvg;
